import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';

/**
 * Operator layout — gates every /operator/* route behind role='operator'.
 * The dashboard content moved to _app.operator.index.tsx so nested
 * routes (tenants, content-orders, conversations, …) actually mount
 * through this Outlet instead of being shadowed by the parent
 * component's hardcoded body.
 */
export const Route = createFileRoute('/_app/operator')({
  staticData: { crumb: 'Operator' },
  beforeLoad: ({ context }) => {
    const ctx = context as { session: { role: string } };
    if (ctx.session.role !== 'operator') {
      throw redirect({ to: '/' });
    }
  },
  component: OperatorLayout,
});

function OperatorLayout() {
  return <Outlet />;
}
